import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useClearLocalStorage = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!pathname?.includes('project/')) localStorage.removeItem('selectedProjectInProjectFeedListPage');
  }, [pathname]);
};

export default useClearLocalStorage;
